<div *ngIf="form">
  <form [formGroup]="form">
    <div class="column">
      <dx-text-area formControlName="code" formField required [label]="'common.code' | translate"></dx-text-area>
      <dx-text-area formControlName="name" formField required [label]="'common.name' | translate"></dx-text-area>
      <dx-text-box formControlName="version" [label]="'common.version' | translate" formField [readOnly]="true"/>
    </div>
  </form>
  <div class="controls">
    <dx-tab-panel>
      <dxi-item style="display: flex;" [title]="'common.steps' | translate | ucfirst">
        <dx-data-grid
          [createComponent]="stepsAddComponent"
          [customParams]="{ parentId: entity!.id }"
          [glamResource]="steps"
        >
          <dxi-column
            [link]="{ editComponent: stepsEditComponent }"
            [allowEditing]="false"
            dataField="instructions"
            dataType="string"
            [caption]="'entity.workProcedure.step.instructions' | translate | ucfirst"
          ></dxi-column>
          <dxi-column
            [allowEditing]="false"
            dataField="instructionsValue"
            dataType="number"
            [caption]="'entity.workProcedure.step.instructionsValue' | translate | ucfirst"
          ></dxi-column>
          <dxi-column
            cellTemplate="checkpointCellTpl"
            [allowEditing]="false"
            dataField="checkpointId"
            [caption]="'common.checkpoint' | translate | ucfirst"
          >
            <div *dxTemplate="let cell of 'checkpointCellTpl'">
              {{ getCheckpointName(cell.data.checkpointId) }}
            </div>
          </dxi-column>
          <dxi-column
            cellTemplate="defaultValuesCellTpl"
            [allowEditing]="false"
            dataField="defaultValues"
            [caption]="'entity.workProcedure.step.defaultValues' | translate | ucfirst"
          >
            <div *dxTemplate="let cell of 'defaultValuesCellTpl'">

              <ng-container *ngIf="cell.data.checkpointDataTypeId === 1; else otherTypes">
                <dx-check-box
                  [value]="toBoolean(cell.data.defaultValues)"
                  [readOnly]="true">
                </dx-check-box>
              </ng-container>

              <ng-template #otherTypes>
                {{ formatDefaultValues(cell.data.defaultValues, cell.data.checkpointDataTypeId) }}
              </ng-template>

            </div>
          </dxi-column>
          <dxi-column
            [allowEditing]="false"
            dataField="required"
            dataType="boolean"
            [caption]="'entity.workProcedure.step.required' | translate | ucfirst"
          ></dxi-column>
        </dx-data-grid>
      </dxi-item>
      <dxi-item [title]="'entity.processSheet.links' | translate | ucfirst">
        <app-work-procedure-links [workProcedureId]="entity?.id"/>
      </dxi-item>
    </dx-tab-panel>
  </div>
</div>
